import axios from 'axios';
import { UserService } from '@/services/user-service';

const store = () => import('@/store');

function handleResponse(request) {
  // store().then((response) => {
  //   response.default.commit('Ui/setUnderMaintenance', false);
  // });
  localStorage.setItem('isUnderMaintenance', 'false');

  return request
    .then((response) => [response.data])
    .catch((error) => {
      if (error.response?.status === 401 && (error.response?.data?.error === 'EXPIRED_TOKEN' || error.response?.data?.error === 'INVALID_TOKEN')) {
        UserService.logout();
        window.location.replace('/');
      } else if (error.response.data.responseCode === 112) {
        if (typeof window !== 'undefined') {
          store().then((response) => {
            response.default.commit('user/setSimaModalStatus', true);
          });
        }
      } else if (error.response?.status === 503) {
        localStorage.setItem('isUnderMaintenance', 'true');
        if (window.location.pathname !== '/under-development') {
          window.location = '/under-development';
        }
      }
      return [null, error.response && error.response.data || error];
    });
}

function wrapRequest(request, wrappers) {
  wrappers.forEach((wrapper) => {
    request = wrapper(request);
  });

  return request;
}

export class HttpClient {

  constructor(requestWrappers = []) {
    this.requestWrappers = requestWrappers;
  }

  get(url, options = {}) {
    return handleResponse(axios(wrapRequest({
      url,
      method: 'get',
      ...options,
    }, this.requestWrappers)));
  }

  post(url, data, options = {}) {
    return handleResponse(axios(wrapRequest({
      url,
      method: 'post',
      data,
      ...options,
    }, this.requestWrappers)));
  }

  delete(url, options = {}) {
    return handleResponse(axios(wrapRequest({
      url,
      method: 'delete',
      ...options,
    }, this.requestWrappers)));
  }

  patch(url, data, options = {}) {
    return handleResponse(axios(wrapRequest({
      url,
      method: 'patch',
      data,
      ...options,
    }, this.requestWrappers)));
  }

  put(url, data, options = {}) {
    return handleResponse(axios(wrapRequest({
      url,
      method: 'put',
      data,
      ...options,
    }, this.requestWrappers)));
  }

}
